/*
    1W: 5th element
    2W: 10th element
    1M: 21st element
    3M: 63rd element
    6M: 126th element

    because 1 week is 5 trading days and 1 month is 21
  */

export const getHorizonToIndexMap = (offset = 0) =>
  new Map<string, number>([
    ['1d', 1 + offset],
    ['1w', 5 + offset],
    ['2w', 10 + offset],
    ['1m', 21 + offset],
    ['2m', 42 + offset],
    ['3m', 63 + offset],
    ['4m', 84 + offset],
    ['5m', 105 + offset],
    ['6m', 126 + offset],
    ['1y', 252 + offset],
    ['12m', 252 + offset],
  ]);
